import { createSlice } from '@reduxjs/toolkit';

export const EmployeeAbsencesSlice = createSlice({
  name: 'employeeAbsences',
  initialState: {
    employeeAbsences_list: [],
    employeeAbsences_employees_select: [], // for the autocomplete
  },
  reducers: {
    setEmployeeAbsencesListRedux: (state, { payload }) => {
      state.employeeAbsences_list = payload;
    },
    setEmployeeAbsencesEmployeesSelectRedux: (state, { payload }) => {
      state.employeeAbsences_employees_select = payload;
    },
  },
});

export const { setEmployeeAbsencesListRedux, setEmployeeAbsencesEmployeesSelectRedux } =
  EmployeeAbsencesSlice.actions;
